export default {
  ContactDetailsFormFields__CALL_DISCLAIMER:
    "Quiet Time observed for voice notifications. Southwest Airlines will not call between 10:00 p.m. and 8:00 a.m. local time. However, if a flight update occurs during the quiet time and is also within four (4) hours prior to scheduled departure, then a voice notification will be sent.",
  ContactDetailsFormFields__COUNTRY_CODE_LABEL: "Country code",
  ContactDetailsFormFields__TEXT_DISCLAIMER:
    "Messages will arrive via text. If you no longer wish to receive messages, you’ll need to opt out. Message frequency varies. Message and data rates apply.",
};
